import { render, staticRenderFns } from "./LayoutSideMenu.vue?vue&type=template&id=26aab6d0&scoped=true&"
import script from "./LayoutSideMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSideMenu.vue?vue&type=style&index=0&id=26aab6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aab6d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26aab6d0')) {
      api.createRecord('26aab6d0', component.options)
    } else {
      api.reload('26aab6d0', component.options)
    }
    module.hot.accept("./LayoutSideMenu.vue?vue&type=template&id=26aab6d0&scoped=true&", function () {
      api.rerender('26aab6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutSideMenu.vue"
export default component.exports